import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";

@Component({
    selector: "core-ui-input-base",
    exportAs: 'coreInputBase',
    templateUrl: "./input-base.component.html",
    styleUrls: ["./input-base.component.scss"],
    standalone: false,
})
export class InputBaseComponent {
    @Input() placeholder = '';
    @Input() type: 'text' | 'password' = 'text';
    @Input() disabled = false;
    @Input() value: string | null = null;
    @Input() variant: 'default' | 'search-large' = 'default';

    @Output() valueChange = new EventEmitter<string>();
    @Output() blur = new EventEmitter<void>();

    @ViewChild('nativeInput', { static: true }) nativeInput!: ElementRef<HTMLInputElement>;

    onInput(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.valueChange.emit(inputElement.value);
    }

    focus() {
        this.nativeInput.nativeElement.focus();
    }

    onBlur() {
        this.blur.emit();
    }
}
